// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manage-item-grid{display:grid;margin-bottom:2rem;grid-template-columns:60px auto 180px 230px;grid-row-gap:17px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.manage-item-grid .select{grid-column:4/5}", ""]);
// Exports
module.exports = exports;
